import {
    adminRecipeTagsControllerGetTags,
    adminRecipeTagsControllerCreateTag,
    adminRecipeTagsControllerUpdateTag,
    adminRecipeTagsControllerDeleteTag,
} from "../api/generated";

// Migrated to the generated client. The server derives the company from the authed principal,
// so the endpoint has no `companyId` query param; the arg is kept for signature parity but not
// forwarded. Returns {data: RecipeTagDto[]} so callers keep reading `res.data`.
export const getRecipeTags = async (companyId) => {
    const {data, error} = await adminRecipeTagsControllerGetTags();
    if (error) throw error;
    return {data};
};

// Migrated. The request body is {name} only — the server ignores any extra `companyId` the
// caller passes (and the generated body type rejects it), so we forward only `name`.
export const saveRecipeTag = async (data) => {
    const {data: resData, error} = await adminRecipeTagsControllerCreateTag({
        body: {name: data.name},
    });
    if (error) throw error;
    return {data: resData};
};

export const updateRecipeTag = async (id, data) => {
    const {data: resData, error} = await adminRecipeTagsControllerUpdateTag({
        path: {id},
        body: {name: data.name},
    });
    if (error) throw error;
    return {data: resData};
};

export const deleteRecipeTag = async (id) => {
    const {data, error} = await adminRecipeTagsControllerDeleteTag({path: {id}});
    if (error) throw error;
    return {data};
};
